/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProgressInput = {
    kind: ProgressInput.kind;
    blockId?: string;
};
export namespace ProgressInput {
    export enum kind {
        LESSON_VIEW = 'lesson_view',
        CHECKPOINT = 'checkpoint',
    }
}

